import { Box, Container, Grid, GridItem, Heading, Link, List, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

export default function TerminosCondicionesAlianzas() {
    return (
        <Container maxWidth="100vw" pt={24} px={{ base: 4, lg: 20 }}>
            <Header />
            <Head>
                <title>Terminos y Condiciones de Alianzas | Grupo Guía</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            href="/terminosycondiciones-guiabroker"
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3} borderLeftColor="#17669D" borderLeftWidth="3px">
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }} pl="5%">
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "2xl", base: "xl" }}
                            mb="8"
                            color="#002B49"
                            fontWeight="extrabold"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Heading>
                    </Box>
                    <Box lineHeight="tall" mb="12">
                        <Heading
                            as="h2"
                            mb="6"
                            mt="2"
                            color="#002B49"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="left"
                        >
                            1. Descripción del Programa – Guía Alianzas
                        </Heading>
                        <Text mb={8}>
                            Guía Alianzas es un programa de beneficios exclusivos dirigido a
                            trabajadores, empleados, estudiantes y miembros de empresas,
                            instituciones o gremios que mantienen una colaboración activa con Grupo
                            Guía.
                            <br />
                            <br />
                            Esta iniciativa está diseñada para brindar condiciones preferenciales en
                            la adquisición de inmuebles seleccionados dentro del portafolio de
                            desarrollos participantes. A través de Guía Alianzas, buscamos acercar
                            soluciones inmobiliarias accesibles y personalizadas a quienes forman
                            parte de estas comunidades, facilitando su camino hacia una inversión
                            patrimonial.
                        </Text>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="7vh"
                            color="#002B49"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="left"
                        >
                            2. Requisitos de Afiliación
                        </Heading>
                        <Text mb={1}>
                            Para ser parte de Guía Alianzas, los interesados deben cumplir con los
                            siguientes requisitos:
                        </Text>
                        <List.Root ml={4}>
                            <List.Item>
                                Registrarse en línea a través del formulario de inscripción oficial.
                            </List.Item>
                            <List.Item>Ser mayor de edad.</List.Item>
                            <List.Item>
                                Aceptar recibir información sobre lanzamientos, promociones y
                                eventos por diversos medios de comunicación (correo electrónico,
                                mensajes de texto, llamadas, etc.).
                            </List.Item>
                            <List.Item>Completar una encuesta inicial de preferencias.</List.Item>
                            <List.Item>
                                Tener un interés genuino en la adquisición de bienes inmuebles.
                            </List.Item>
                            <List.Item>
                                Mostrar comportamiento ético y respetuoso dentro de la comunidad.
                            </List.Item>
                            <List.Item>
                                Participar activamente en webinars, reuniones o eventos organizados.
                            </List.Item>
                            <List.Item>
                                Mantener una actitud colaborativa y de interacción con otros
                                miembros.
                            </List.Item>
                        </List.Root>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="7vh"
                            color="#002B49"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="left"
                        >
                            3. Participación y Permanencia
                        </Heading>
                        <List.Root>
                            <List.Item>
                                La participación en el programa implica una interacción activa
                                dentro de la comunidad.
                            </List.Item>
                            <List.Item>
                                Los miembros que no participen, no interactúen o no demuestren
                                interés en las actividades podrán ser dados de baja.
                            </List.Item>
                            <List.Item>
                                La membresía es limitada y sujeta a disponibilidad.
                            </List.Item>
                            <List.Item>
                                Los miembros pueden darse de baja en cualquier momento solicitándolo
                                a través de los canales oficiales de contacto.
                                servicioaclientes@grupoguia.mx
                            </List.Item>
                        </List.Root>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="7vh"
                            color="#002B49"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="left"
                        >
                            4. Beneficios del Programa
                        </Heading>
                        <Text mb={1}>
                            Los miembros de Guía Alianzas podrán acceder a los siguientes
                            beneficios:
                        </Text>
                        <List.Root ml={4}>
                            <List.Item>
                                Acceso prioritario a nuevos lanzamientos inmobiliarios.
                            </List.Item>
                            <List.Item>
                                Invitaciones a eventos exclusivos y webinars especializados.
                            </List.Item>
                            <List.Item>
                                Asesoramiento preferencial y personalizado en inversiones
                                inmobiliarias.
                            </List.Item>
                            <List.Item>
                                Descuentos y beneficios especiales en proyectos seleccionados.
                            </List.Item>
                            <List.Item>
                                Red de networking con otros miembros interesados en bienes
                                inmuebles.
                            </List.Item>
                        </List.Root>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="7vh"
                            color="#002B49"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="left"
                        >
                            5. Baja del Programa Guía Alianzas
                        </Heading>
                        <Text mb={1}>
                            Se reserva el derecho de dar de baja a cualquier miembro que:
                        </Text>
                        <List.Root ml={4}>
                            <List.Item>
                                No cumpla con los requisitos establecidos en estos términos y
                                condiciones.
                            </List.Item>
                            <List.Item>No participe activamente en la comunidad.</List.Item>
                            <List.Item>
                                Incumpla con normas de comportamiento ético y respetuoso.
                            </List.Item>
                            <List.Item>
                                No demuestre interés real en la adquisición de bienes inmuebles.
                            </List.Item>
                            <List.Item>
                                Realice acciones que perjudiquen la integridad del programa o de sus
                                miembros.
                            </List.Item>
                        </List.Root>
                        <Heading
                            as="h2"
                            mb="4"
                            mt="7vh"
                            color="#002B49"
                            fontWeight="400"
                            fontSize={{ md: "2xl", base: "xl" }}
                            textAlign="left"
                        >
                            6. Modificaciones y Condiciones Adicionales 
                        </Heading>
                        <Text mb={2}>
                            Grupo Guía se reserva el derecho de modificar los términos y condiciones
                            del programa en cualquier momento. Cualquier cambio será notificado a
                            los miembros a través de los canales de comunicación oficiales.
                            <br />
                            <br />
                            El descuento será aplicable presentando un gafete vigente o un
                            comprobante de nómina actualizado que acredite su relación laboral con
                            la empresa.
                            <br />
                            <br />
                            Al registrarse en Guía Alianzas, el usuario acepta estos términos y
                            condiciones, así como el Aviso de Privacidad de Grupo Guia Excelencia
                            Inmobiliaria S.A de C.V en su totalidad y se compromete a cumplir con
                            los lineamientos establecidos.
                            <br />
                            <br />
                            Contacto: Para cualquier consulta, duda o solicitud de baja del
                            programa, los miembros pueden comunicarse a través de
                            atencionaclientes@grupoguia.mx o al WhatsApp 33 1868 1590.
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
}
